'use strict'
import _ from "lodash";
import ViewBase from '../view-base.view';
import { Dialog } from 'construct-ui';
import loginModel from '../../models/login.model';
import vocModel from '../../models/voc/voc.model';
import UserBadgeComponent from '../../components/common/user-badge.component';
import VocImageGalleryView from './voc.image-gallery.view';
import VocHistoryView from './voc.history.view';
import VocHistoryAddView from './voc.history-add.view'
import { staticUrls } from '../../config/constants';

export default function VocDetailView() {
    ViewBase.call(this);

    const maximumNumberOfFiles = 9;

    let currentCountry;

    let inputDataModelCommunication = { message: '', messageCharCount: 0 };
    let _chatMessages = [];

    let _galleryFiles = [];

    let _isAddingNewVocRecordEnabled = false;
    let _isAddingNewRequestorFileEnabled = false;

    let _isPopupShowImageGallery = false;
    let _isPopupShowVocHistory = false;
    let _isPopupShowVocHistoryItemAdd = false;
    let _selectedFileId;
    let _isFromRequestor = false;
    let _isFileUploadOnly = false;

    let hideVocDetailPage = () => { };

    let _selectedVocId;
    let _selectedVoc;

    let _loadVocDetail = () => {
        this.showLoading();

        vocModel.getSingleVoc(
            (result) => {
                this.hideLoading();

                console.log(result);

                _selectedVoc = result;

                _isAddingNewRequestorFileEnabled = _selectedVoc.createUserId == loginModel.credentials.userID;
                _isAddingNewVocRecordEnabled = loginModel.credentials.admin || _selectedVoc.picUserId == loginModel.credentials.userID;

                _loadChatMessages();

            }, (error) => {
                this.hideLoading();

                _selectedVoc = null;
                _selectedVocId = '';

                this.handleError(error);
            },
            _selectedVocId);
    }

    let _showImageFilesInGallery = (files, selectedFileMasterId) => {
        _isPopupShowImageGallery = true;
        _galleryFiles = files;
        _selectedFileId = selectedFileMasterId;
    }

    let _showVocHistory = () => {
        _isPopupShowVocHistory = true;
    }

    let _getCommunicationMessage = (e) => {
        inputDataModelCommunication.messageCharCount = e.target.value.length;

        if (inputDataModelCommunication.messageCharCount <= 200) {
            inputDataModelCommunication.message = e.target.value;
        } else {
            inputDataModelCommunication.messageCharCount = 200;
        }

    }

    let _checkEnterKey = (e) => {
        if (e.keyCode == 13) {
            _addChatMessage();
        }
    }

    let _createNewHistoryItem = (isFileUploadOnly, isFromRequestor) => {
        _isFromRequestor = isFromRequestor;
        _isFileUploadOnly = isFileUploadOnly;
        _isPopupShowVocHistoryItemAdd = true;
    }

    let _reloadChat = () => {
        _loadChatMessages();
    }

    let _loadChatMessages = () => {
        vocModel.getVocMessages(
            (result) => {
                _chatMessages = result;
            }, (error) => {
                _chatMessages = [];
                this.handleError(error);
            },
            _selectedVocId);
    }

    let _addChatMessage = () => {
        vocModel.addVocMessage(
            (result) => {

                inputDataModelCommunication.message = '';
                inputDataModelCommunication.messageCharCount = 0;

                _reloadChat();

            }, (error) => {
                this.handleError(error);
            },
            _selectedVocId,
            inputDataModelCommunication.message);
    }


    let _showDeleteFileConfirmation = (vocFileMapID) => {
        this.showConfirm(this.getText("LT00000455", "Are you sure you want to delete this file?"), this.getText("LT00000457", "Delete File"), (e) => {

            if (e == "YES") {
                vocModel.deactivateFile(
                    () => {
                        this.showMessage(this.getText("LT00000456", "The file has been deleted."), this.getText("LT00000457", "Delete File"));

                        _loadVocDetail();
                    }, (error) => {
                        this.handleError(error);
                    },
                    vocFileMapID);
            }
        });

    }

    let onUpdateVocInfoComplete = () => {
        _isPopupShowVocHistoryItemAdd = false;
        _loadVocDetail();
    }

    return {
        oninit: (vnode) => {

            if (vnode.attrs.hideVocDetailPage && vnode.attrs.vocId) {
                hideVocDetailPage = vnode.attrs.hideVocDetailPage;
                _selectedVocId = vnode.attrs.vocId;

                _loadVocDetail();
            }

            currentCountry = loginModel.credentials.country;
        },
        onupdate: (vnode) => {
            if (loginModel.credentials.country !== currentCountry) {

                currentCountry = loginModel.credentials.country;
            }
        },
        view: ({ attrs }) => {

            let _isHavingRequestorFiles = (_selectedVoc && _selectedVoc.registrationFiles && _selectedVoc.registrationFiles.length > 0) || _isAddingNewRequestorFileEnabled;
            let _isHavingResolutionFiles = (_selectedVoc && _selectedVoc.resolutionFiles && _selectedVoc.resolutionFiles.length > 0) || _isAddingNewVocRecordEnabled;

            return m('.col-md-12',
                [
                    m('.d-flex',
                        m('.flex-grow-1',
                            _selectedVoc && m('.w-100',
                                m('h2',
                                    m('i.bi.bi-arrow-left.cursor-pointer', {
                                        onclick: hideVocDetailPage
                                    }),
                                    _selectedVoc.isUrgentYN == 'Y' && m('strong.text-danger.me-3', '!'),
                                    m('span', `[#${_selectedVoc.vocIdString}] ${ _selectedVoc.title}`)
                                )
                            ),
                        ),
                        _selectedVoc && _isAddingNewVocRecordEnabled && m('div',
                            m('button.btn.btn-sm.btn-primary',
                                { onclick: () => { _createNewHistoryItem(false, false); } }, [
                                m("i.bi.bi-plus-lg.me-0") 
                            ])
                        )
                    ),
                    !_selectedVoc && _selectedVocId !== '' && m('.card.mb-3.mt-2',
                        m('.card-body.py-3',
                            m('.row',
                                m('.container', {
                                    style: "height: 400px;"
                                })
                            )
                        )
                    ),
                    !_selectedVoc && _selectedVocId === '' && m('.card.mb-3.mt-2',
                        m('.card-body.py-3',
                            m('.row',
                                m('.container',
                                    m('span', this.getText("EM00000141", "No records found."))
                                )
                            )
                        )
                    ),
                    _selectedVoc && m('.row.g-3', [
                        m('.col-xl-3.col-md-4',
                            m('.sticky-voc-card-left',
                                m('.card',
                                    m('.card-body',
                                        m('div',
                                            [
                                                m('.d-flex', { style: 'margin-bottom: 2rem;' },
                                                    m('.flex-grow-1',
                                                        m('span.badge.bg-primary',
                                                            { style: "background-color: transparent !important; border: 1px solid #0d6efd; color: #0d6efd; width: unset;" },
                                                            _selectedVoc.statusName
                                                        )
                                                    ),
                                                    m('div',
                                                        m('span.small', _selectedVoc.numberOfDays + ' Day' + (_selectedVoc.numberOfDays != 1 ? 's' : ''))
                                                    )
                                                ),
                                                m('table', { style: 'width: 100%; font-size: .875em; margin-top: 10px;' },
                                                    m('tr',
                                                        m('td.pb-2.align-top', { style: 'width: 40%;' }, m('strong', 'Product: ')),
                                                        m('td.pb-2.align-top', _selectedVoc.gscmDiv)
                                                    ),
                                                    m('tr',
                                                        m('td.pb-2.align-top', { style: 'width: 40%;' }, m('strong', 'Category: ')),
                                                        m('td.pb-2.align-top', _selectedVoc.category)
                                                    ),
                                                    m('tr',
                                                        m('td.pb-2.align-top', { style: 'width: 40%;' }, m('strong', 'Sub Category: ')),
                                                        m('td.pb-2.align-top', _selectedVoc.subCategory)
                                                    ),
                                                    m('tr',
                                                        m('td.pb-2.align-top', { style: 'width: 40%;' }, m('strong', 'Item: ')),
                                                        m('td.pb-2.align-top', _selectedVoc.item)
                                                    ),
                                                    m('tr',
                                                        m('td.pb-2.align-top', { style: 'width: 40%;' }, m('strong', 'Site: ')),
                                                        m('td.pb-2.align-top', '[' + _selectedVoc.siteId + '] - ' + _selectedVoc.siteName)
                                                    ),
                                                    m('tr',
                                                        m('td.pb-2.align-top', { style: 'width: 40%;' }, m('strong', 'Due Date: ')),
                                                        m('td.pb-2.align-top', _selectedVoc.dueDate)
                                                    ),
                                                    m('tr',
                                                        m('td.pb-2.align-top', { style: 'width: 40%;' }, m('strong', 'Commented By: ')),
                                                        m('td.pb-2.align-top', _selectedVoc.commentedBy)
                                                    ),
                                                ),
                                                m('hr'),
                                                m('h5.card-title', 'Requestor'),
                                                m(UserBadgeComponent,
                                                    {
                                                        image: _selectedVoc.requestorPhotoString,
                                                        imageSize: '40px',
                                                        flexGap: '0.5rem'
                                                    },
                                                    m('span', { style: 'word-break: break-word;font-size: 0.875rem;' }, _selectedVoc.requestorName),
                                                ),

                                            ]
                                        ),
                                        m('hr'),
                                        m('div',
                                            [
                                                m('h5.card-title', 'Person-In-Charge'),
                                                !(_selectedVoc.picName && _selectedVoc.picName.length > 0) && m('span.text-warning', this.getText("LT00000458", "No PIC Assigned")),
                                                _selectedVoc.picName && _selectedVoc.picName.length > 0 && m(UserBadgeComponent,
                                                    {
                                                        image: _selectedVoc.picPhotoString,
                                                        imageSize: '40px',
                                                        flexGap: '0.5rem'
                                                    },
                                                    m('span', { style: 'word-break: break-word;font-size: 0.875rem;' }, _selectedVoc.picName),
                                                ),
                                            ]
                                        ),

                                    )
                                ),
                                m("button.btn.btn-primary[type='button']",
                                    {
                                        style: 'width: 100%; margin-top: 10px;',
                                        onclick: _showVocHistory
                                    }, this.getText("LT00000459", "View VOC History"))
                            )

                        ),
                        m('.col-xl-9.col-md-8',
                            m('.row',
                                [
                                    m('.col-xl-8.col-md-12',
                                        m('.card.mb-3',
                                            m('.card-body',
                                                [
                                                    m('h5.card-title', 'Reported VOC'),
                                                    m('span.card-subtitle.mb-2.text-muted', { style: "font-size: .875em !important;" }, 'Registered Date/Time: ' + _selectedVoc.loggedDateTime),
                                                    m('.row.mt-3', [
                                                        m(_isHavingRequestorFiles ? '.col-md-4' : '.col-md-12', { style: "font-size: .875em !important;" }, _selectedVoc.description),
                                                        _isHavingRequestorFiles && m('.col-md-8', { style: 'border-left: 1px solid var(--blue-color-light);' },
                                                            m('.row',
                                                                [
                                                                    _selectedVoc.registrationFiles && _selectedVoc.registrationFiles.length > 0 && _selectedVoc.registrationFiles.map(function (file, index) {

                                                                        return m(".col-xl-4.col-6", { style: "margin-bottom: 24px;" },
                                                                            [
                                                                                file.photoFlag == 'Y' && m('div', { style: "position: relative; text-align: center; aspect-ratio: 4 / 3;" },
                                                                                    m("img", {
                                                                                        src: file.fileContent,
                                                                                        style: "width: 100%; height: 100%; cursor: pointer; object-fit: cover; object-position: center;",
                                                                                        onclick: () => { _showImageFilesInGallery(_selectedVoc.registrationFiles, file.fileMasterId); }
                                                                                    }),

                                                                                    file.deleteFlag == 'Y' && m(".voc-file-delete.text-danger", { onclick: () => { _showDeleteFileConfirmation(file.vocFileMapID); } }, [m("i", { class: "bi bi-trash me-0" })]),
                                                                                ),



                                                                                file.photoFlag != 'Y' && m('div', { style: 'position: relative; text-align: center; aspect-ratio: 4 / 3;' },
                                                                                    m("img", {
                                                                                        src: staticUrls.fileImage,
                                                                                        style: "width: 100%; height: 100%; cursor: pointer; object-fit: cover; object-position: center;",
                                                                                        onclick: () => { _showImageFilesInGallery(_selectedVoc.registrationFiles, file.fileMasterId); }
                                                                                    }
                                                                                    ),

                                                                                    file.deleteFlag == 'Y' && m(".voc-file-delete.text-danger", { onclick: () => { _showDeleteFileConfirmation(file.vocFileMapID); } }, [m("i", { class: "bi bi-trash me-0" })]),

                                                                                    m(".fs-1", {
                                                                                        onclick: () => { _showImageFilesInGallery(_selectedVoc.registrationFiles, file.fileMasterId); }
                                                                                    },
                                                                                        m(".file-info-text",
                                                                                            {
                                                                                                title: file.fileName,
                                                                                            },
                                                                                            file.fileName
                                                                                        )
                                                                                    )
                                                                                ),

                                                                                m(".row", { style: "margin-top: 6px; font-size: 12px;" }, [
                                                                                    m(".col-12", [m("i", { "class": "bi bi-clock" }), m("span", file.createDate)])
                                                                                ])
                                                                            ]
                                                                        )
                                                                    }),

                                                                    (!_selectedVoc.registrationFiles || _selectedVoc.registrationFiles.length < maximumNumberOfFiles) && _isAddingNewRequestorFileEnabled && m('.col-xl-4.col-6', { style: "margin-bottom: 24px;" },
                                                                        m('div', { style: 'position: relative; text-align: center; aspect-ratio: 4 / 3;' },
                                                                            m('button.btn.btn-outline-primary.w-100.h-100',
                                                                                { onclick: () => { _createNewHistoryItem(true, true); } }, [
                                                                                m("i.bi.bi-plus-lg.me-0")
                                                                            ]
                                                                            )
                                                                        )
                                                                    )
                                                                ]),
                                                            _isAddingNewRequestorFileEnabled && m('span.text-warning', { style: "font-size: .875em !important;" }, '* Maximum ' + maximumNumberOfFiles + ' attachments allowed only.')
                                                        )
                                                    ])
                                                ]
                                            )
                                        ),

                                        m('.card.mb-3',
                                            _selectedVoc.resolutionDateTime && m('.card-body',
                                                [
                                                    m('h5.card-title', 'Resolution'),
                                                    !(_selectedVoc.resolutionUserName && _selectedVoc.resolutionUserName.length > 0) && m('span.card-subtitle.mb-2.text-muted', { style: 'font-size: 0.875em !important;' }, 'Last Updated: ' + _selectedVoc.resolutionDateTime),
                                                    _selectedVoc.resolutionUserName && _selectedVoc.resolutionUserName.length > 0 && m('span.card-subtitle.mb-2.text-muted', { style: 'font-size: 0.875em !important;' }, 'Last Updated: ' + _selectedVoc.resolutionDateTime + ', by ' + _selectedVoc.resolutionUserName),
                                                    m('.row.mt-3', [
                                                        m(_isHavingResolutionFiles ? '.col-md-4' : '.col-md-12', { style: "font-size: .875em !important;" }, _selectedVoc.resolutionRemark),
                                                        _isHavingResolutionFiles && m('.col-md-8', { style: 'border-left: 1px solid var(--blue-color-light);' },
                                                            m('.row',
                                                                [
                                                                    _selectedVoc.resolutionFiles && _selectedVoc.resolutionFiles.length > 0 && _selectedVoc.resolutionFiles.map(function (file, index) {

                                                                        return m(".col-xl-4.col-6", { style: "margin-bottom: 24px;" },
                                                                            [
                                                                                file.photoFlag == 'Y' && m('div', { style: "position: relative; text-align: center; aspect-ratio: 4 / 3;" },
                                                                                    m("img", {
                                                                                        src: file.fileContent,
                                                                                        style: "width: 100%; height: 100%; cursor: pointer; object-fit: cover; object-position: center;",
                                                                                        onclick: () => { _showImageFilesInGallery(_selectedVoc.resolutionFiles, file.fileMasterId); }
                                                                                    }),

                                                                                    file.deleteFlag == 'Y' && m(".voc-file-delete.text-danger", { onclick: () => { _showDeleteFileConfirmation(file.vocFileMapID); } }, [m("i", { class: "bi bi-trash me-0" })]),
                                                                                ),

                                                                                file.photoFlag != 'Y' && m('div', { style: 'position: relative; text-align: center; aspect-ratio: 4 / 3;' },
                                                                                    m("img", {
                                                                                        src: staticUrls.fileImage,
                                                                                        style: "width: 100%; height: 100%; cursor: pointer; object-fit: cover; object-position: center;",
                                                                                        onclick: () => { _showImageFilesInGallery(_selectedVoc.resolutionFiles, file.fileMasterId); }
                                                                                    }
                                                                                    ),

                                                                                    file.deleteFlag == 'Y' && m(".voc-file-delete.text-danger", { onclick: () => { _showDeleteFileConfirmation(file.vocFileMapID); } }, [m("i", { class: "bi bi-trash me-0" })]),

                                                                                    m(".fs-1", {
                                                                                        onclick: () => { _showImageFilesInGallery(_selectedVoc.resolutionFiles, file.fileMasterId); }
                                                                                    },
                                                                                        m(".file-info-text",
                                                                                            {
                                                                                                title: file.fileName,
                                                                                            },
                                                                                            file.fileName
                                                                                        )
                                                                                    )
                                                                                ),

                                                                                m(".row", { style: "margin-top: 6px; font-size: 12px;" }, [
                                                                                    m(".col-12", [m("i", { "class": "bi bi-person" }), m("span", file.createUserName)]),
                                                                                    m(".col-12", [m("i", { "class": "bi bi-clock" }), m("span", file.createDate)])
                                                                                ])
                                                                            ]
                                                                        )
                                                                    }),

                                                                    (!_selectedVoc.resolutionFiles || _selectedVoc.resolutionFiles.length < maximumNumberOfFiles) && _isAddingNewVocRecordEnabled && m('.col-xl-4.col-6', { style: "margin-bottom: 24px;" },
                                                                        m('div', { style: 'position: relative; text-align: center; aspect-ratio: 4 / 3;' },
                                                                            m('button.btn.btn-outline-primary.w-100.h-100',
                                                                                { onclick: () => { _createNewHistoryItem(true, false); } }, [
                                                                                m("i.bi.bi-plus-lg.me-0")
                                                                            ]
                                                                            )
                                                                        )
                                                                    )
                                                                ]),
                                                            _isAddingNewVocRecordEnabled && m('span.text-warning', { style: "font-size: .875em !important;" }, '* Maximum ' + maximumNumberOfFiles + ' attachments allowed only.')
                                                        )
                                                    ])
                                                ]
                                            )
                                        )
                                    ),
                                    m('.col-xl-4.col-md-12',
                                        m('.card.sticky-voc-card-right', { style: 'height: calc(100vh - 15rem) !important;' },
                                            m('.card-body',
                                                m('.mesgs', { style: 'height: calc(100vh - 15rem) !important;' },

                                                    m('.d-flex',
                                                        m('.flex-grow-1',
                                                            m('h5.card-title', 'Communications'),
                                                        ),
                                                        _isAddingNewVocRecordEnabled && m('div',
                                                            m('a',
                                                                { href: 'javascript:;', onclick: _reloadChat }, [
                                                                m("i.bi.bi-arrow-clockwise")
                                                            ]

                                                            )
                                                        )
                                                    ),
                                                    m('.msg_history', { style: 'height: calc(100vh - 22rem) !important;' },
                                                        _chatMessages && _chatMessages.map(function (msg, index) {

                                                            if (msg.createUserId == loginModel.credentials.userID) {
                                                                return m('.incoming_msg', { style: "margin-top: 10px;" }, [
                                                                    m('.schedule-user-info.d-flex',
                                                                        {
                                                                            class: 'chat-profile',
                                                                            style: {
                                                                                'gap': '0.5rem',
                                                                            }
                                                                        },
                                                                        m('.user-text-info.d-flex.flex-column.flex-fill.align-items-end',
                                                                            m('.sent_msg',
                                                                                m('.sent_withd_msg', [
                                                                                    m('p', [
                                                                                        m('strong', msg.createUserName),
                                                                                        m('br'),
                                                                                        m('span', msg.message)
                                                                                    ]),
                                                                                    m('span.chat_time_date.text-end', msg.createDateFormat)
                                                                                ])
                                                                            )
                                                                        ),
                                                                        m('.user-image-wrapper.flex-shrink-0', {
                                                                            style: {
                                                                                'width': '40px',
                                                                                'height': '40px',
                                                                                'margin-right': '4px',
                                                                            }
                                                                        },
                                                                            m('img', {
                                                                                src: _.isEmpty(msg.photoString)
                                                                                    ? staticUrls.emptyUserImage
                                                                                    : msg.photoString,
                                                                            })
                                                                        ),
                                                                    ),


                                                                ])
                                                            }


                                                            return m('.incoming_msg', { style: "margin-top: 10px;" }, [
                                                                m(UserBadgeComponent,
                                                                    {
                                                                        class: 'chat-profile',
                                                                        image: msg.photoString,
                                                                        imageSize: '40px',
                                                                        flexGap: '0.5rem'
                                                                    },
                                                                    m('.received_msg',
                                                                        m('.received_withd_msg', [
                                                                            m('p', [
                                                                                m('strong', msg.createUserName),
                                                                                m('br'),
                                                                                m('span', msg.message)
                                                                            ]),
                                                                            m('span.chat_time_date', msg.createDateFormat)
                                                                        ])
                                                                    )
                                                                ),

                                                            ])
                                                        })

                                                    ),
                                                    m('hr', { style: 'margin: 0.4rem 0;' }),
                                                    m('.d-flex', [
                                                        m('.me-3', { style: 'flex-grow: 20;' },
                                                            m('input[type=text].write_msg.form-control.form-control-bg.w-100', {
                                                                style: "font-size: 12px !important;",
                                                                placeholder: "Type a message",
                                                                value: inputDataModelCommunication.message,
                                                                oninput: _getCommunicationMessage,
                                                                onkeydown: _checkEnterKey,
                                                            }),
                                                            m('.text-end' + (inputDataModelCommunication.messageCharCount > 150 ? ".text-danger" : ""), {
                                                                style: "font-size: 12px;"
                                                            }, inputDataModelCommunication.messageCharCount + '/200')
                                                        ),
                                                        m('.text-end', { style: 'flex-grow: 1;' },
                                                            m('button[type=button].btn.btn-primary', { style: "font-size: 12px !important;", onclick: _addChatMessage }, [
                                                                m('i.bi.bi-chat', { style: "margin-right: 0;" })
                                                            ])
                                                        )
                                                    ])
                                                )
                                            )
                                        )
                                    ),
                                ]
                            )
                        )

                    ]),
                    m(Dialog, {
                        isOpen: _isPopupShowImageGallery,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { _isPopupShowImageGallery = false; },
                        title: this.getText("LT00000460", "Gallery"),
                        content: m(VocImageGalleryView, {
                            onPopupClose: () => { _isPopupShowImageGallery = false; },
                            files: _galleryFiles,
                            selectedFileId: _selectedFileId
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                    m(Dialog, {
                        isOpen: _isPopupShowVocHistoryItemAdd,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { _isPopupShowVocHistoryItemAdd = false; },
                        title: _isFileUploadOnly ? this.getText("LT00000461", "Upload Attachments") : this.getText("LT00000462", "Update VOC Information"),
                        content: m(VocHistoryAddView, {
                            onPopupClose: () => { _isPopupShowVocHistoryItemAdd = false; },
                            onSaveComplete: onUpdateVocInfoComplete,
                            vocId: _selectedVocId,
                            isFromRequestor: _isFromRequestor,
                            isFileUploadOnly: _isFileUploadOnly
                        }),
                        "class": "cui-dialog-xxl"
                    }),
                    m(Dialog, {
                        isOpen: _isPopupShowVocHistory,
                        transitionDuration: 200,
                        closeOnOutsideClick: false,
                        onClose: () => { _isPopupShowVocHistory = false; },
                        title: this.getText("LT00000463", "VOC History"),
                        content: m(VocHistoryView, {
                            onPopupClose: () => { _isPopupShowVocHistory = false; },
                            vocId: _selectedVocId
                        }),
                        "class": "cui-dialog-fluid"
                    }),
                    this.getBaseViews()
                ]);
        },
    };
}
